import { useQuery } from "@apollo/client";
import { gql } from "@/gql";

const GET_USER_PENDING_INVITATIONS_QUERY = gql(`
  query GetUserPendingInvitations {
    getUserPendingInvitations {
      id
      email
      status
      message
      token
      salonId
      salonName
      workerId
      workerName
      createdAt
      expiresAt
    }
  }
`);

export const useGetPendingInvitations = () => {
  const query = useQuery(GET_USER_PENDING_INVITATIONS_QUERY);

  return {
    invitations: query.data?.getUserPendingInvitations || [],
    loading: query.loading,
    error: query.error,
    refetch: query.refetch,
  };
};
